// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"LllCE","lhsWrapper":"aua2T","rhsWrapper":"WmN2s","launchButton":"tY9kt","clickButton":"Zzpe_","tatbText":"lsQzG","closeBtn":"fsHo3"};